import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useHttp from "../../hooks/use-http";
import { endPoints } from "../../config/end-points";
import { submissionActions } from "../../store/submission-store";

const SubmissionDetail = ({ submissionId, onClose, onStatusChange, onDelete }) => {
  const dispatch = useDispatch();
  const { sendRequest } = useHttp();
  const [submission, setSubmission] = useState(null);

  useEffect(() => {
    if (!submissionId) return;
    sendRequest(
      {
        url: `${endPoints.formSubmissions}/${submissionId}`,
        method: "GET",
      },
      (response) => {
        if (response.status === 200) {
          setSubmission(response.data);
          if (response.data.status === "read") {
            dispatch(
              submissionActions.updateSubmissionStatus({
                id: submissionId,
                status: "read",
              })
            );
          }
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submissionId]);

  const parseSubmissionData = (dataStr) => {
    try {
      return JSON.parse(dataStr);
    } catch {
      return {};
    }
  };

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const fieldLabels = {
    name: "Name",
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    phone: "Phone",
    subject: "Subject",
    company: "Company",
    address: "Address",
    message: "Message",
  };

  if (!submission) {
    return (
      <div className="sub-modal-overlay" onClick={onClose}>
        <div className="sub-modal" onClick={(e) => e.stopPropagation()}>
          <div className="sub-modal-loading">Loading...</div>
        </div>
      </div>
    );
  }

  const data = parseSubmissionData(submission.submission_data);

  return (
    <div className="sub-modal-overlay" onClick={onClose}>
      <div className="sub-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="sub-modal-header">
          <div>
            <h5>Submission Details</h5>
            <p className="sub-modal-date">{formatDate(submission.createdAt)}</p>
          </div>
          <button className="sub-modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        {/* Meta */}
        <div className="sub-modal-meta">
          <div className="sub-meta-item">
            <span className="sub-meta-label">Project</span>
            <span className="sub-meta-value">{submission.project?.name || "—"}</span>
          </div>
          <div className="sub-meta-item">
            <span className="sub-meta-label">Page</span>
            <span className="sub-meta-value">{submission.page_name || "—"}</span>
          </div>
          <div className="sub-meta-item">
            <span className="sub-meta-label">Status</span>
            <span className={`sub-status sub-status--${submission.status}`}>
              {submission.status}
            </span>
          </div>
          {submission.ip_address && (
            <div className="sub-meta-item">
              <span className="sub-meta-label">IP</span>
              <span className="sub-meta-ip">{submission.ip_address}</span>
            </div>
          )}
        </div>

        {/* Fields */}
        <div className="sub-modal-fields">
          {Object.entries(data).map(([key, value]) => (
            <div key={key} className="sub-field">
              <label className="sub-field-label">
                {fieldLabels[key] || key}
              </label>
              <div
                className={`sub-field-value${
                  key === "message" ? " sub-field-value--message" : ""
                }${!value ? " sub-field-value--empty" : ""}`}
              >
                {value || "Empty"}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="sub-modal-footer">
          {submission.status !== "archived" && (
            <button
              className="sub-modal-btn"
              onClick={() => onStatusChange(submission.id, "archived")}
            >
              <i className="bi bi-archive"></i>Archive
            </button>
          )}
          {submission.status === "archived" && (
            <button
              className="sub-modal-btn"
              onClick={() => onStatusChange(submission.id, "read")}
            >
              <i className="bi bi-arrow-counterclockwise"></i>Unarchive
            </button>
          )}
          <button
            className="sub-modal-btn sub-modal-btn--danger"
            onClick={() => onDelete(submission.id)}
          >
            <i className="bi bi-trash"></i>Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionDetail;
